module.exports = __webpack_public_path__ + "static/m_solution12-828ff2a7e28bae5766195fa74e1b5fde.png";